import { render, staticRenderFns } from "./AppInfoBox.vue?vue&type=template&id=7a17f3fa&scoped=true&"
import script from "./AppInfoBox.vue?vue&type=script&lang=js&"
export * from "./AppInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoBox.vue?vue&type=style&index=0&id=7a17f3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a17f3fa",
  null
  
)

export default component.exports